import { canUseDOM } from '@/app/common/utils/canUseDOM';

const MODAL_OPEN_CLASS = 'modal-open';

// The body class is shared by every OpenXModal instance, so it must be reference-counted:
// lateral modals mount nested (closed) OpenXModals inside their content, and stacked modals
// close while the one below is still open — an unconditional classList.remove from either
// strips the class the open modal depends on, leaving react-remove-scroll's overflow:hidden
// active with no padding compensation (the scrollbar-width layout shift).
let modalOpenCount = 0;

export const addModalOpenClass = () => {
  if (!canUseDOM) return;
  modalOpenCount += 1;
  if (modalOpenCount > 1) return;
  // Measure the real scrollbar width right before hiding it — window.innerWidth includes the
  // scrollbar, clientWidth excludes it, so the difference is exact. Re-measuring on each
  // unlocked open handles zoom changes and OS setting changes since initial page load. Skip
  // when another mechanism (CSW lock, react-remove-scroll) already hid the scrollbar: the
  // gap would measure 0 and collapse the compensation padding mid-lock.
  const isAlreadyLocked =
    document.body.classList.contains('csw-body-scroll-lock') || document.body.hasAttribute('data-scroll-locked');
  if (!isAlreadyLocked) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
  }
  document.body.classList.add(MODAL_OPEN_CLASS);
};

export const removeModalOpenClass = () => {
  if (!canUseDOM) return;
  modalOpenCount = Math.max(0, modalOpenCount - 1);
  if (modalOpenCount === 0) {
    document.body.classList.remove(MODAL_OPEN_CLASS);
  }
};

export const getScrollbarWidth = () => {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  // @ts-ignore
  outer.style.msOverflowStyle = 'scrollbar';
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  if (document.body.contains(outer)) {
    outer.remove();
  }

  return scrollbarWidth;
};
